<section class="fixed inset-0 z-50 flex min-h-screen flex-col overflow-hidden bg-mock-blue-100" aria-modal="true"
  role="dialog">
  <div class="h-10 bg-brand-primary"></div>

  <div
    class="exam-recommendation-shell flex min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-6 sm:px-6 sm:py-8">
    <img [src]="imageEnum.EMPTY_CORNER" alt="" class="exam-recommendation-corner pointer-events-none select-none"
      aria-hidden="true" />

    <article
      class="relative z-10 m-auto w-full max-w-2.xl shrink-0 overflow-hidden rounded-xl border border-slate-300 bg-transparent shadow-xl"
      (click)="$event.stopPropagation()">
      <div class="bg-brand-primary px-4 py-2">
        <h2 class="text-base font-semibold text-white">Full Screen Required</h2>
      </div>

      <div class="py-4 px-5">
        <div class="flex flex-col items-center text-center">
          <img [src]="imageEnum.MONITOR" alt="monitor.svg" class="mb-3">

          <h3 class="text-lg font-normal leading-7 text-text-primary sm:px-6">
            For this examination, full screen mode is required.
          </h3>

          <p class="sub-paragraph text-base mt-2 text-text-secondary">
            Please enter full screen mode to begin the examination. Once full screen mode is enabled, you will proceed
            to the instructions page.
            <br />
            <span class="font-semibold text-text-primary">Press F11</span>
            or use the button below to enter full screen mode.
          </p>

        </div>
      </div>

      <div class="border-t border-mock-gray-200 pb-4 pt-4 mx-5 sm:mx-6">
        <app-primary-button text="Enter Full Screen" ariaLabel="Enter full screen"
          buttonClass="h-10 w-full rounded-md px-4 text-sm font-medium tracking-normal transition hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary active:opacity-90"
          (buttonClick)="onEnterFullScreen()" />
      </div>
    </article>
  </div>
</section>